import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  page: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  headerWrapper: {
    flex: '0 0 auto'
  },
  root: {
    width: '100%',
    marginTop: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  card: {
    width: '80%',
    flex: 1,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4
  },
  cardBody: {
    height: '100%',
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 260,
    justifyContent: 'center'
  },
  dropzone: {
    width: '100%',
    border: `2px dashed ${theme.palette.divider}`,
    borderRadius: 8,
    padding: 32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    cursor: 'pointer',
    position: 'relative',
    transition: 'border-color 0.2s, background-color 0.2s',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.action.hover
    }
  },
  dropzoneActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.action.hover
  },
  uploadIcon: {
    fontSize: 64,
    color: theme.palette.text.disabled,
    marginBottom: 24
  },
  dropzoneText: {
    marginBottom: 24,
    maxWidth: 320,
    color: theme.palette.text.secondary
  },
  helperText: {
    marginTop: 16,
    color: theme.palette.text.secondary
  },
  filePreview: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: 16,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8
  },
  fileNameText: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  actions: {
    marginTop: 24,
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    gap: 8
  },
  loader: {
    justifyContent: 'center',
    display: 'flex',
    paddingTop: 20
  }
}));
